var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateYourFreeListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23629_14239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 2.33325C21.6187 2.33325 22.2122 2.57908 22.6498 3.01667C23.0873 3.45425 23.3332 4.04775 23.3332 4.66659V23.3333C23.3332 23.9521 23.0873 24.5456 22.6498 24.9832C22.2122 25.4208 21.6187 25.6666 20.9998 25.6666H6.99984C6.381 25.6666 5.78751 25.4208 5.34992 24.9832C4.91234 24.5456 4.6665 23.9521 4.6665 23.3333V4.66659C4.6665 4.04775 4.91234 3.45425 5.34992 3.01667C5.78751 2.57908 6.381 2.33325 6.99984 2.33325H20.9998ZM13.9998 15.1666H10.4998C10.1904 15.1666 9.89367 15.2895 9.67488 15.5083C9.45609 15.7271 9.33317 16.0238 9.33317 16.3333C9.33317 16.6427 9.45609 16.9394 9.67488 17.1582C9.89367 17.377 10.1904 17.4999 10.4998 17.4999H13.9998C14.3093 17.4999 14.606 17.377 14.8248 17.1582C15.0436 16.9394 15.1665 16.6427 15.1665 16.3333C15.1665 16.0238 15.0436 15.7271 14.8248 15.5083C14.606 15.2895 14.3093 15.1666 13.9998 15.1666ZM17.4998 9.33325H10.4998C10.2025 9.33358 9.91647 9.44744 9.70024 9.65158C9.48401 9.85571 9.3539 10.1347 9.33647 10.4315C9.31904 10.7284 9.41562 11.0207 9.60648 11.2487C9.79733 11.4768 10.0681 11.6233 10.3633 11.6584L10.4998 11.6666H17.4998C17.7972 11.6663 18.0832 11.5524 18.2994 11.3483C18.5157 11.1441 18.6458 10.8651 18.6632 10.5683C18.6806 10.2714 18.5841 9.97914 18.3932 9.75111C18.2023 9.52309 17.9316 9.37654 17.6363 9.34142L17.4998 9.33325Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23629_14239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateYourFreeListing);
export default __webpack_public_path__ + "static/media/create-your-free-listing.d17ac7f64a13f3845f25525ea29c0396.svg";
export { ForwardRef as ReactComponent };